var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormItem', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "prop": "shouhuoxinxi",
      "label": "收货信息"
    }
  }, [(!_vm.editable && _vm.data && ((!_vm.data.shouhuodiqu || !_vm.data.shouhuodiqu[0]) && !_vm.data.shouhuodizhi && !_vm.data.shouhuorenxingming && !_vm.data.shouhuodianhua)) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n            未填写\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.editable || _vm.data.shouhuodizhi) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodiqu",
      "label": "地区"
    }
  }, [(_vm.editable) ? _c('div', {
    staticStyle: {
      "margin-top": "2px",
      "min-width": "200px"
    }
  }, [_c('Cascader', {
    attrs: {
      "data": _vm.diqudata,
      "filterable": ""
    },
    on: {
      "on-change": _vm.diquChanged
    },
    model: {
      value: (_vm.form.shouhuodiqu),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodiqu", $$v)
      },
      expression: "form.shouhuodiqu"
    }
  })], 1) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodiqu ? _vm.data.shouhuodiqu.join('/') : ''))])]) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuodizhi) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodizhi",
      "label": "详细地址"
    }
  }, [(_vm.editable) ? _c('Input', {
    style: (("width: " + (_vm.data && _vm.data.menpaihao?220:280) + "px;")),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuodizhi),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodizhi", $$v)
      },
      expression: "form.shouhuodizhi"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodizhi))])], 1) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.menpaihao) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "menpaihao",
      "label": "门牌号"
    }
  }, [(_vm.editable) ? _c('Input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.menpaihao),
      callback: function($$v) {
        _vm.$set(_vm.form, "menpaihao", $$v)
      },
      expression: "form.menpaihao"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.menpaihao || ''))])], 1) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuorenxingming) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuorenxingming",
      "label": "收货人姓名"
    }
  }, [(_vm.editable) ? _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuorenxingming),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuorenxingming", $$v)
      },
      expression: "form.shouhuorenxingming"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuorenxingming))])], 1) : _vm._e(), _vm._v(" "), (_vm.editable || _vm.data.shouhuodianhua) ? _c('FormItem', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "prop": "shouhuodianhua",
      "label": "收货电话"
    }
  }, [(_vm.editable) ? _c('Input', {
    style: (("width: " + (_vm.data && _vm.data.menpaihao?110:140) + "px;")),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.shouhuodianhua),
      callback: function($$v) {
        _vm.$set(_vm.form, "shouhuodianhua", $$v)
      },
      expression: "form.shouhuodianhua"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.shouhuodianhua))])], 1) : _vm._e(), _vm._v(" "), (_vm.options && _vm.options.beizhuOn) ? _c('FormItem', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "prop": "beizhu",
      "label": "备注"
    }
  }, [(_vm.editable) ? _c('Input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.beizhu),
      callback: function($$v) {
        _vm.$set(_vm.form, "beizhu", $$v)
      },
      expression: "form.beizhu"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.data.beizhu))]), _vm._v(" "), (!_vm.editable && !_vm.data.beizhu) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("无")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.editable) ? _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "placement": "right-start",
      "transfer": ""
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v("智能识别地址")]), _vm._v(" "), (_vm.addressParseModal) ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "df"
  }, [_c('Input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请输入待识别文字"
    },
    on: {
      "input": function($event) {
        return _vm.addressParseModal.calculate()
      },
      "on-enter": _vm.addressParseModal.confirm
    },
    model: {
      value: (_vm.addressParseModal.content),
      callback: function($$v) {
        _vm.$set(_vm.addressParseModal, "content", $$v)
      },
      expression: "addressParseModal.content"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addressParseModal.confirm
    }
  }, [_vm._v("应用")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "110px"
    }
  }, [(_vm.addressParseModal.result && _vm.addressParseModal.result.shouhuodizhi) ? _c('div', {
    staticStyle: {
      "color": "#aaa"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), (_vm.addressParseModal.result.shouhuodiqu && _vm.addressParseModal.result.shouhuodiqu[0]) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodiqu.join('/')) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuodizhi) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodizhi) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuorenxingming) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuorenxingming) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.addressParseModal.result.shouhuodianhua) ? _c('div', [_c('Icon', {
    attrs: {
      "type": "md-checkmark",
      "color": "#20bf64"
    }
  }), _vm._v(" " + _vm._s(_vm.addressParseModal.result.shouhuodianhua) + "\n                    ")], 1) : _vm._e()]) : _c('div', {
    staticClass: "center",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "color": "#aaa"
    }
  }, [_vm._v("\n                    暂无识别结果\n                ")])])]) : _vm._e()]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75d3ef7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d3ef7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AddressInput.vue
// module id = +Z5u
// module chunks = 142